module.exports = __webpack_public_path__ + "static/media/vakancy.16192338.png";